
    <img [src]="imageUrl() | async" alt="Example Image" class="legend-icon-container">


